/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserReportControllerCreateMonthlyGenerationsSnapshot201ResponseData { 
    status?: UserReportControllerCreateMonthlyGenerationsSnapshot201ResponseData.StatusEnum;
    message?: string;
    snapshotId?: string;
}
export namespace UserReportControllerCreateMonthlyGenerationsSnapshot201ResponseData {
    export type StatusEnum = 'created' | 'exists' | 'error';
    export const StatusEnum = {
        Created: 'created' as StatusEnum,
        Exists: 'exists' as StatusEnum,
        Error: 'error' as StatusEnum
    };
}


